import style from './StorageTabPage.module.css';

import ListNavigationDrawer from 'widgets/ListNavigationDrawer';
import { MODE_NAVIGATION } from 'consts/navigationDrawer.consts';
import Samples from './Samples';
import { useRef } from 'react';
import { treeStore } from 'store/mobx/tree.store';
import { observer } from 'mobx-react-lite';

const StorageTabPage = observer(({ mode, setWidget }) => {
  const refContainer = useRef(null);
  const { selectedNode } = treeStore;

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <ListNavigationDrawer
        ref={refContainer}
        mode={MODE_NAVIGATION.tree}
        initialFirstPaneSize={25}
        minSizeFirstPane={25}
        allowResize
      >
        {selectedNode && <Samples mode={mode} setWidget={setWidget} />}
      </ListNavigationDrawer>
    </div>
  );
});

export default StorageTabPage;
